import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { FeatherEdit2, FeatherTrash2 } from '../ui/icons';
import './LeaveApplicationList.css';

const LeaveApplicationList = ({ leaves, onEdit, onDelete, showActions = false }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getStatusVariant = (status) => {
    switch (status) {
      case 'approved':
        return 'success';
      case 'rejected':
        return 'error';
      case 'pending':
        return 'warning';
      default:
        return 'neutral';
    }
  };

  if (!leaves || leaves.length === 0) {
    return (
      <div className="leave-application-list-empty">
        <p>No leave applications found</p>
      </div>
    );
  }

  return (
    <div className="leave-application-list">
      {leaves.map((leave) => (
        <div key={leave.id} className="leave-application-card">
          <div className="leave-application-header">
            <div className="leave-application-info">
              <div className="leave-application-dates">
                <span className="leave-date">{formatDate(leave.start_date)}</span>
                <span className="leave-date-separator">to</span>
                <span className="leave-date">{formatDate(leave.end_date)}</span>
              </div>
              {leave.user && (
                <span className="leave-application-employee">
                  {leave.user.display_name || leave.user.email}
                </span>
              )}
            </div>
            <Badge variant={getStatusVariant(leave.status)}>
              {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
            </Badge>
          </div>
          
          <div className="leave-application-details">
            <div className="leave-application-detail-item">
              <span className="detail-label">Total Days:</span>
              <span className="detail-value">{leave.total_days} {leave.total_days === 1 ? 'day' : 'days'}</span>
            </div>
            {leave.leave_type && (
              <div className="leave-application-detail-item">
                <span className="detail-label">Type:</span>
                <span className="detail-value">{leave.leave_type}</span>
              </div>
            )}
            {leave.reason && (
              <div className="leave-application-detail-item full-width">
                <span className="detail-label">Reason:</span>
                <span className="detail-value">{leave.reason}</span>
              </div>
            )}
            {leave.rejection_reason && (
              <div className="leave-application-detail-item full-width">
                <span className="detail-label rejection">Rejection Reason:</span>
                <span className="detail-value rejection">{leave.rejection_reason}</span>
              </div>
            )}
            {leave.approved_by_user && (
              <div className="leave-application-detail-item">
                <span className="detail-label">
                  {leave.status === 'approved' ? 'Approved by:' : 'Rejected by:'}
                </span>
                <span className="detail-value">
                  {leave.approved_by_user.display_name || leave.approved_by_user.email}
                </span>
              </div>
            )}
            {leave.approved_at && (
              <div className="leave-application-detail-item">
                <span className="detail-label">
                  {leave.status === 'approved' ? 'Approved on:' : 'Rejected on:'}
                </span>
                <span className="detail-value">{formatDate(leave.approved_at)}</span>
              </div>
            )}
          </div>

          {showActions && leave.status === 'pending' && (
            <div className="leave-application-actions">
              {onEdit && (
                <Button
                  variant="neutral-tertiary"
                  icon={<FeatherEdit2 />}
                  onClick={() => onEdit(leave)}
                >
                  Edit
                </Button>
              )}
              {onDelete && (
                <Button
                  variant="neutral-tertiary"
                  icon={<FeatherTrash2 />}
                  onClick={() => onDelete(leave.id)}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LeaveApplicationList;

